(() => {
  'use strict';
  if (window.__ES_EMPTY_CART__) return;
  window.__ES_EMPTY_CART__ = true;

  const root = document.querySelector('[data-es-ec-carousel]');
  if (!root) return;

  const track = root.querySelector('.es-ec-carousel__track');
  const prev = root.querySelector('.es-ec-carousel__btn.is-prev');
  const next = root.querySelector('.es-ec-carousel__btn.is-next');
  if (!track || !prev || !next) return;

  let raf = 0;
  const reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const step = () => {
    const first = track.querySelector('.es-ec-carousel__item');
    return first ? Math.max(240, Math.round(first.getBoundingClientRect().width + 16)) : 320;
  };

  const update = () => {
    raf = 0;
    const max = Math.max(0, track.scrollWidth - track.clientWidth);
    const left = Math.max(0, track.scrollLeft);
    const needed = max > 12;
    prev.hidden = !needed;
    next.hidden = !needed;
    if (!needed) return;
    const atStart = left <= 4;
    const atEnd = left >= max - 4;
    prev.disabled = atStart;
    next.disabled = atEnd;
    prev.setAttribute('aria-disabled', atStart ? 'true' : 'false');
    next.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
  };

  const schedule = () => {
    if (raf) return;
    raf = requestAnimationFrame(update);
  };

  const move = direction => {
    track.scrollBy({ left: step() * direction, behavior: reducedMotion ? 'auto' : 'smooth' });
    window.setTimeout(schedule, reducedMotion ? 0 : 240);
  };

  prev.addEventListener('click', () => move(-1));
  next.addEventListener('click', () => move(1));
  track.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  schedule();
})();
